import React from 'react'
import { CategoriesOptionsStyles } from './Style'
import { useQueryClient } from '@tanstack/react-query'
import { Button, Chip } from 'components/Form'
import { categoriesWithIcons } from 'keys/categories'
import { Divider, SvgIcon } from '@mui/material'
import { groupBy } from 'lodash'
import { ReactComponent as AbilityIcon } from 'assets/icons/AbilityGroup.svg'
import qc from 'keys/queryClient'

const CategoriesOptions = React.forwardRef((props, ref) => {
    const { value, onChange, multiple, isOptionEqualToValue, onClose } = props; // ה-props שהעברנו מהאב
    const queryClient = useQueryClient();
    const categories = queryClient.getQueryData([qc.categories]);

    const categoriesByGroup = groupBy(categories, (item) => item.ability_group || "כללי");

   // פונקציית עזר לבדיקה האם קטגוריה נבחרה - תומכת בסינגל ומולטי
    const isSelected = (category) => {
        if (!value) return false;

        if (multiple) {
            if (!Array.isArray(value)) return false;
            return value.some(v => isOptionEqualToValue ? isOptionEqualToValue(v, category) : v.id === category.id);
        } else {
            // מצב Single
            return isOptionEqualToValue ? isOptionEqualToValue(value, category) : value.id === category.id;
        }
    };

    // לוגיקת ה-Toggle
    const handleToggle = (category) => {
        // הסרנו מכאן את ה-e.preventDefault ואת e.stopPropagation
        // כי ה-div שעוטף את הכפתור כבר מטפל בזה ב-onMouseDown

        if (multiple) {
            const currentlySelected = Array.isArray(value) ? value : [];
            const exists = isSelected(category);

            let newValue;
            if (exists) {
                newValue = currentlySelected.filter(v =>
                    isOptionEqualToValue ? !isOptionEqualToValue(v, category) : v.id !== category.id
                );
            } else {
                newValue = [...currentlySelected, category];
            }

            onChange(newValue);
        }
        else {
            // לוגיקת Single-select
            onChange(category);
            // סגירת התפריט לאחר בחירה במצב יחיד (אם הועברה פונקציית onClose מהאב)
            if (onClose) {
                onClose();
            }
        }
    };

    return (
        <CategoriesOptionsStyles ref={ref}>
            {Object.entries(categoriesByGroup || {}).map(([group, groupCategories]) => (
                <div className='group-and-categories' key={group}>
                    <div className='ability-item'>
                        <SvgIcon size="small" component={AbilityIcon} inheritViewBox />
                        <div className='ability-group-name'>{group}</div>
                    </div>
                    <Divider sx={{ borderColor: "#EAF3FF" }} />
                    <div className='group-categories'>
                        {groupCategories.map((category) => {
                            const categoryItem = categoriesWithIcons?.[category.name] || categoriesWithIcons.default;
                            const active = isSelected(category); // האם הכפתור דלוק?

                            return (
                                <div
                                    key={category.id}
                                    onMouseDown={(e) => {
                                        if (e && typeof e.preventDefault === 'function') {
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }
                                    }}
                                >
                                    <Button
                                        key={category.id}
                                        size="small"
                                        color={active ? "processing" : "thirdly4"}
                                        action={() => handleToggle(category)}
                                    >
                                        <SvgIcon
                                            className={active ? "active-icon" : ""}
                                            component={categoryItem?.icon}
                                            inheritViewBox
                                        />
                                        {category.label}
                                    </Button>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ))}
        </CategoriesOptionsStyles>
    );
})

export default CategoriesOptions